/**
 * Номер запису для показу поза таблицями модуля (прототип v4: шапка «101», крихта «Завдання 101», картки пов'язаних записів, дочірні рядки,
 * міні-форма, історія — завжди число без префікса типу): код > 0 — число; без коду — позначення без префікса («TSK-101» → «101»), якщо воно
 * має вигляд «ПРЕФІКС-число»; інакше — позначення як є. Чиста функція.
 */
export function recordCode(display: string | null | undefined, code?: number | null): string {
  if (typeof code === 'number' && Number.isFinite(code) && code > 0) return String(code);
  const text = display ?? '';
  const match = /^[^\s-]+-(\d+)$/.exec(text);
  return match?.[1] ?? text;
}
